import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/nav.scss";
import { getAllDataInSection } from "../data/flowChartData.js";
import Card from "../subviews/Card";
import Question from "../subviews/Question";
import parse from "../parse";

const w = window;
const down_arrow = require("../thumb/down_arrow.png");

class AlgorithmSection extends React.Component {
  constructor(props) {
    super(props);
    this.contentLoop = this.contentLoop.bind(this);
  }

  getData() {
    const {
      title,
      tool,
      type,
      flows,
      content,
    } = getAllDataInSection(this.props.algorithm);
    // let fClass = figure_ar === "landscape" ? "figure-l" : "figure-p";
    let flow = null;
    if (flows && flows.length) {
      flow = flows[0].algorithm;
    }

    
    const visibleContent = content.filter(c => eval(c.visible));
    const questions = content.filter( c => c.type);
    var visibleQuestions = [];
    questions.forEach((question) => {
      var vis = eval(question.visible);
      w[question.id + "_v"] = vis;
      if (vis) {
        visibleQuestions.push(question);
      }
    });

    return {
      title: title,
      tool: tool,
      imageSource: '',
      fClass: 'figure-l',
      content: visibleContent,
      flow: flow,
    };
  }

  contentLoop(contents) {
    let list = null;
    if (contents) {
      if (Array.isArray(contents)) {
        list = contents.map((content) => this.contentCard(content));
      } else {
        list = this.contentCard(contents);
      }
    }
    return list;
  }


  titleCard(title) {
    return (<Card
        cardClass={"management transparent"}
        title={title}
        algorithm={true}
      />);
  }

  contentCard(content) {
    return content.type ? (
        <Question
        question={content}
        answerSelected={
          content.type === "button"
            ? this.props.handleButton
            : this.props.answerSelected
        }
        value={content.value}
        tab={this.props.tab}
        currentSelection={w[content.id]}
      />) : this.styledCard(content)
  }

  styledCard(content) {
    if (content.style == "down_arrow") {
      return (
        <div className="card transparent arrow_box">
          <img className="down_arrow" src={down_arrow}></img>
        </div>
      );
    } else {
      return (<Card
        cardClass={"management " + content.style}
        algorithm={true}
        text={
          <div>
            <div>
              <div className="content">
                {content.text.map((line) => (
                  <div>{parse(line)}</div>
                ))}
              </div>
            </div>
          </div>
        }
      />
    );
    }
  }

  buildFollowUp(f, title) {
    return (
      <div>
        <h5 style={{ color: "#7a006e" }}>{title}</h5>
        <Card cardClass={"management"} text={this.buildFollowUpList(f)} />
      </div>
    );
  }

  buildFollowUpList(fu) {
    const followUp = fu.map((f) =>
      f.text.map((suggestion) => <div>{parse(suggestion)}</div>)
    );
    return followUp;
  }

  buildQuestions(questions) {
    return (
      <div>
        {questions.map((question) => (
          <Question
            question={question}
            answerSelected={
              question.type === "button"
                ? this.props.handleButton
                : this.props.answerSelected
            }
            value={question.value}
            tab={this.props.tab}
            currentSelection={w[question.id]}
          />
        ))}
      </div>
    );
  }

  buildPostContentViews(post) {
    console.log(['aa', post]);

    let postCon = [];
    let align = "";
    if (typeof post === "string") {
      postCon.push(<div>{parse(post)}</div>);
    } else {
      // todo
    }
    return <div className={align}>{postCon}</div>;
  }

  render() {
    const {
      title,
      tool,
      imageSource,
      fClass,
      content,
      flow,
    } = this.getData();
    // const image = require("../figures/" + imageSource + ".jpg");

    if (flow) {
      this.props.nextAlgorithm(flow);
    }

    return (
      <div>
        {this.titleCard(title)}
        {this.contentLoop(content)}
        {tool ? this.contentCard({type: "button", "figure": tool, text: "View Tool >"}) : null}
      </div>
    );
  }
}

export default AlgorithmSection;
